/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { NonceChallengeOptions } from './NonceChallengeOptions';
import {
    NonceChallengeOptionsFromJSON,
    NonceChallengeOptionsFromJSONTyped,
    NonceChallengeOptionsToJSON,
} from './NonceChallengeOptions';

/**
 * 
 * @export
 * @interface NonceChallenge
 */
export interface NonceChallenge {
    /**
     * 
     * @type {string}
     * @memberof NonceChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof NonceChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof NonceChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {NonceChallengeOptions}
     * @memberof NonceChallenge
     */
    options?: NonceChallengeOptions;
}

/**
 * Check if a given object implements the NonceChallenge interface.
 */
export function instanceOfNonceChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;

    return isInstance;
}

export function NonceChallengeFromJSON(json: any): NonceChallenge {
    return NonceChallengeFromJSONTyped(json, false);
}

export function NonceChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': !exists(json, 'options') ? undefined : NonceChallengeOptionsFromJSON(json['options']),
    };
}

export function NonceChallengeToJSON(value?: NonceChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': NonceChallengeOptionsToJSON(value.options),
    };
}

